;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('tel', TelFilter)

  /**
   * Class Filter for format telephone number
   * @class TelFilter
   * @constructor
   */
  function TelFilter () {
    /**
     * Return a human readable telephone
     * @param {String} tel
     * @returns {String}
     */
    var operation = function (tel) {
      if (!tel) {
        return ''
      }

      var value = tel.toString().trim().replace(/^\+/, '')

      if (value.match(/[^0-9]/)) {
        return tel
      }

      var tab = []

      switch (value.length) {
        case 10: // +1PPP####### -> C (PPP) ###-####
          for (var i = 0, len = value.length; i < len; i += 2) {
            tab.push(value.substr(i, 2))
          }
          return tab.join(' ')
        default:
          return tel
      }
    }

    /**
     * Return callback to execute TelFilter
     */
    return operation
  }
})(window.angular)
